import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { GuardsCheckEnd, NavigationEnd, Router } from '@angular/router';
import { LoginService, SessionCookieService } from '@docpath/linces-angular-components';
import { DpAppSwitcherService, DpMainConfig, DpMenuItem, NavAction, User } from '@docpath/webcomponents';
import { faCog, faGauge, faHome, faSignal } from '@fortawesome/free-solid-svg-icons';
import { environment } from 'src/environments/environment';

import { Constants } from './constants/constants';
import { RoutingPath } from './constants/routing-path';
import { AppService } from './shared/services/app.service';
import { CloudService } from './shared/services/cloud.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  title = 'prueba';
  logged = false;
  openMenu = false;

  mainApp: DpMenuItem = new DpMenuItem();
  bottomLinks: NavAction[] = [];
  topLinks: NavAction[] = [];
  userApps?: DpMenuItem[] = [];
  showLoading = false;
  user!: User;

  mainView: DpMainConfig;

  // eslint-disable-next-line max-params
  constructor(
    appSwitcherService: DpAppSwitcherService,
    private readonly router: Router,
    private readonly loginService: LoginService,
    private readonly sessionCookieService: SessionCookieService,
    private readonly cloudService: CloudService,
    private readonly appService: AppService,
    private readonly titleService: Title
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof GuardsCheckEnd) {
        this.logged = (event.url !== `/${RoutingPath.PATH_LOGIN}`
          && event.url !== `/${RoutingPath.PATH_404}`
          && event.url !== `/${RoutingPath.PATH_CLOUD}`);
      }
      else if (event instanceof NavigationEnd) {
        if (event.urlAfterRedirects === '/login') {
            this.titleService.setTitle('Welcome');
        } else {
            this.titleService.setTitle(`DocPath - ${environment.APP_NAME}`);
        }
      }
    });

    this.mainView = {
      mainApp: this.mainApp,
      bottomLinks: this.bottomLinks,
      showUserApps: true,
      topLinks: this.topLinks,
      user: this.user,
      userApps: this.userApps
  };
  }

  ngOnInit(): void {

    this.appService.userLogged.subscribe(isLogged => {
      this.logged = isLogged;

      this.initData();
    });

    this.initData();

  }

  private initData(): void {

    this.initTopLinks();
    this.initUser();
    this.initNavActions();
    this.initMainApp();
    this.initUserApps();
    this.loadUserApps();
    
  }

  logout(): void {
      this.loginService.logout();
      this.appService.notifyUserLogged(false);
  }

  initUserApps() {
    const user = this.sessionCookieService.getSessionCookie()?.user;
    
    if (user?.role === Constants.ROLE_LOCAL
      || this.cloudService.isModeCloud()) {
      this.userApps = undefined;
    }
  }

  loadUserApps(): void {
    const user = this.sessionCookieService.getSessionCookie()?.user;

    this.showLoading = true;

    if (user?.role !== Constants.ROLE_LOCAL) {
      this.loginService.getUserApplications().subscribe(apps => {
        this.userApps = apps.map(app => new DpMenuItem(app.type, app.url, app.type));
        this.mainView.userApps = this.userApps;
        this.showLoading = false;
      });
    } else {
      this.userApps = undefined;
    }
  }

  private initNavActions(): void {
    this.bottomLinks = [];
    const navActionsList = [
        new NavAction({
            url: `/${RoutingPath.PATH_CONFIGURATION}`,
            icon: { name: faCog },
            label: 'app.configuration.label',
            tooltip: 'app.configuration.tooltip'
        })
    ];

    this.loadUserActions(navActionsList, false);
    this.mainView.bottomLinks = this.bottomLinks;
  }

  private initTopLinks(): void {
    this.topLinks = [];
    const navActionsList = [
      new NavAction({
        url: `/${RoutingPath.PATH_HOME}`,
        icon: { name: faHome },
        label: 'app.home.label',
        tooltip: 'app.home.tooltip' }),
      new NavAction({
        url: `/${RoutingPath.PATH_STATISTICS}`,
        icon: { name: faSignal },
        label: 'app.statistics.label',
        tooltip: 'app.statistics.tooltip' }),
      new NavAction({
        url: `/${RoutingPath.PATH_MONITORING}`,
        icon: { name: faGauge },
        label: 'app.monitoring.label',
        tooltip: 'app.monitoring.tooltip' })
    ];

    this.loadUserActions(navActionsList, true);
    this.mainView.topLinks = this.topLinks;
  }

  private loadUserActions(navActionsList: NavAction[], isTopAction: boolean): void {
    const paths = this.sessionCookieService.getSessionCookie()?.authorization.paths;

    navActionsList.forEach(navAction => {
      if (paths?.includes(navAction.url)) {
        if (isTopAction) {
          this.topLinks.push(navAction);
        } else {
          this.bottomLinks.push(navAction);
        }
      }
    });
  }

  private initUser(): void {
    const user = this.sessionCookieService.getSessionCookie()?.user;

    if (user) {
        this.user = new User(user.name, '', user.name, user.email);
        this.mainView.user = this.user;
    }
  }

  private initMainApp(): void {
    this.mainApp = new DpMenuItem(environment.APP_NAME, environment.BASE_URL, 'assets/images/logo.svg');
    this.mainView.mainApp = this.mainApp;
  }

}

